import { clsx } from 'clsx'
import type { ComponentProps } from 'react'
import * as RadixTabs from '@radix-ui/react-tabs'
import { Button } from '../Button/Button'
import type { ButtonSize } from '../Button/Button.helpers'
import { tabButton, tabsListBase, tabsListLayout, tabsListSize, tabsListType, tabsRoot } from './Tabs.css'

type RootProps = { fullWidth?: boolean } & ComponentProps<typeof RadixTabs.Root>

const Root = ({ fullWidth = false, ...forwardedProps }: RootProps) => {
  return <RadixTabs.Root {...forwardedProps} className={tabsRoot[fullWidth ? 'fullWidth' : 'default']} />
}

type ListProps = {
  size?: 'mini' | 'small' | 'medium' | 'large'
  type: 'default' | 'filled'
  layout?: 'default' | 'evenly-spaced'
} & ComponentProps<typeof RadixTabs.List>

const List = ({ size = 'medium', type, layout = 'default', ...forwardedProps }: ListProps) => {
  return (
    <RadixTabs.List
      {...forwardedProps}
      className={clsx(tabsListBase, tabsListSize[size], tabsListType[type], tabsListLayout[layout])}
    />
  )
}

type TriggerProps = {
  size?: ButtonSize
} & ComponentProps<typeof RadixTabs.Trigger>

const Trigger = ({ children, size = 'medium', ...forwardedProps }: TriggerProps) => {
  return (
    <RadixTabs.Trigger {...forwardedProps} asChild={true}>
      <Button className={tabButton} variant="ghost" size={size}>
        {children}
      </Button>
    </RadixTabs.Trigger>
  )
}

export const Tabs = {
  Content: RadixTabs.Content,
  List,
  Root,
  Trigger,
}
